import { render } from "./B2bSteps.vue?vue&type=template&id=45866f69&scoped=true&lang=pug"
import script from "./B2bSteps.vue?vue&type=script&lang=js"
export * from "./B2bSteps.vue?vue&type=script&lang=js"

import "./B2bSteps.vue?vue&type=style&index=0&id=45866f69&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45866f69"]])

export default __exports__